import script from "./TocThreeDContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TocThreeDContent.vue?vue&type=script&setup=true&lang=ts"

import "./TocThreeDContent.vue?vue&type=style&index=0&id=26ce2ef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ce2ef2"]])

export default __exports__